import React, {ReactElement, useEffect, useState, CSSProperties} from 'react';
import useWindowDimensions from '../../core/utils/window.utils';
import offerScanner from '../../assets/json/offerScanner2.json';
import Lottie from 'react-lottie';

import {
  setAppBarTitle,
  setBackNavEnabled,
  setBackNavAction,
} from '../../redux/globalSlice';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';
import {useHistory} from 'react-router';
import OfferModal from './offerModal';
import {
  getAccessToken,
  getStoreInformation,
  getUser,
  setCustomerCouponsCountinLS,
} from '../../core/localstorage-data';
import {getWithExpiry, setWithExpiry} from '../../core/localstorage-utils';
import {
  couponPoints,
  fetchCouponPoints,
  resetCouponAPIResponse,
  setCustomerCouponsCount,
  errorInCouponApi,
  couponIsLoading,
} from '../../redux/offerSlice';
import ScannerView from './views/ScannerView';
import QrCode from '../storescan/BarcodeScanner';
import StoreCodeMessage from '../storescan/StoreCodeMessage';
import {BackButtonAction} from '../../core/utils/string.util';
import {
  HOME_ROUTE_PATH,
  UNLOCKED_OFFERS_ROUTE_PATH,
} from '../../routes/route-constants';
import cogoToast from 'cogo-toast';
import ErrorToast from '../../components/notifications/ErrorToast';
import {
  setPageName,
  viewPromotionEventGA,
  walletOfferClickedEvent,
} from '../../lib/tagmanager';
import {pageName} from '../../lib/constants';
import InformationToast from '../../components/notifications/InformationToast';

type AllOffers = {
  customerCouponId: number;
  mobileNumber: string;
  couponGeneratedTime: string;
  couponCode: string;
  description: string;
  validity: string;
  keyId: string;
  couponType: string;
  regionId: string;
  detailsId: number;
};
const Offers = (): ReactElement => {
  const navigate = useHistory();
  const dispatch = useAppDispatch();
  //const storeCode=getStoreInformation();
  const storeCode = getStoreInformation().store_code;

  const couponPointsDataFromLocalStorage = getWithExpiry(
    'coupon_point_details',
  );
  const [showUnlockedModel, setShowUnlockedModel] = useState(false);
  const [canScan, setCanScan] = useState(true);

  const [offer, setOffer] = useState<AllOffers | null>(null);

  const couponApiHasError = useAppSelector(errorInCouponApi);
  const coupanApiHasLoaded = useAppSelector(couponIsLoading);
  const couponPointsDataFromAPI = useAppSelector(couponPoints);
  const [openofferGif, setOpenOfferGif] = useState(true);
  useEffect(() => {
    setPageName(pageName.scanOfferQrPage);
    setTimeout(() => {
      setOpenOfferGif(false);
    }, 5000);
  }, []);

  const offerscannerGif = {
    loop: true,
    autoplay: true,
    animationData: offerScanner,
    rendererSettings: {
      // preserveAspectRatio: "xMidYMid slice"
    },
  };

  useEffect(() => {
    //console.log('ssssssssssssssssssssssssss', couponPointsDataFromAPI);
    if (couponPointsDataFromAPI !== null) {
      const couponList = couponPointsDataFromAPI.customerCoupons;
      const userData = getUser();
      //setWithExpiry('coupon_card_number', userData?.cardNumber);
      if (couponList && couponList.length) {
        walletOfferClickedEvent(
          couponPointsDataFromAPI?.keyId,
          couponList[0].customerCouponId.toString(),
        );
        viewPromotionEventGA(
          couponList[0].couponCode,
          couponList[0].description,
          couponList[0].customerCouponId,
        );
        setOffer(couponList[0]);
        setShowUnlockedModel(true);
      } else {
        cogoToast.success(
          <InformationToast
            title="Offers"
            description="Keep scanning to unlock more offers"
          />,
          {
            hideAfter: 5,
            renderIcon: () => {
              return null;
            },
          },
        );
        setCanScan(false);

        setTimeout(() => {
          setCanScan(true);
        }, 2000);
      }
    }
    if (couponApiHasError != '') {
      cogoToast.success(
        <InformationToast
          title="Offers"
          description="Keep scanning to unlock more offers"
        />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
      setTimeout(() => {
        setCanScan(true);
      }, 2000);
    }
  }, [couponPointsDataFromAPI, couponApiHasError, coupanApiHasLoaded]);

  useEffect(() => {
    dispatch(setAppBarTitle('My offers'));
    dispatch(setBackNavEnabled(true));
    dispatch(setBackNavAction(BackButtonAction.TO_HOME));

    return () => {
      // Clean up the subscription
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
      dispatch(setBackNavAction(undefined));

      dispatch(resetCouponAPIResponse());
    };
  }, []);

  function handleButtonClick() {
    navigate.push(`${HOME_ROUTE_PATH}${UNLOCKED_OFFERS_ROUTE_PATH}`);
  }
  const closeModalHandler = () => {
    setShowUnlockedModel(false);
  };

  function handleScan(data: string) {
    console.log('dataaaaaaaaaaaaaaaaaaa====>', data);
    setCanScan(false);
    const pathPatternMatcher = new RegExp(
      /https:\/\/[a-zA-Z0-9.]+\.landmarkbuddy\.com\/urlredirect\?id=\w+/,
    );
    const accessToken = getAccessToken();
    const path = data;
    const isMatched = pathPatternMatcher.test(path);
    if (accessToken && isMatched) {
      const unique_id = path.split('=')[1];

      const parameters = {
        accessToken: getAccessToken(),
        payload: {
          keyId: unique_id,
          storecode: storeCode,
        },
      };
      dispatch(fetchCouponPoints(parameters));
    } else {
      setTimeout(() => {
        setCanScan(true);
      }, 2000);
    }
  }

  function checkIsCouponExisting() {
    const couponfromapi = couponPointsDataFromAPI?.customerCoupons;
    const changedCoupon: any[] = [];
    if (couponfromapi) {
      couponfromapi.forEach(coupon => {
        const couponMatches = couponPointsDataFromLocalStorage.some(
          (elem: {customerCouponId: number}) =>
            elem.customerCouponId === coupon.customerCouponId,
        );
        if (couponMatches === false) {
          changedCoupon.push(coupon);
        }
      });
    }
    return changedCoupon;
  }
  function handleModalClose(type: string) {
    if (couponPointsDataFromAPI) {
      if (
        couponPointsDataFromAPI.customerCoupons &&
        couponPointsDataFromAPI.customerCoupons.length > 0
      ) {
        if (
          couponPointsDataFromLocalStorage &&
          couponPointsDataFromLocalStorage.length > 0
        ) {
          const changedCoupons = checkIsCouponExisting();
          if (changedCoupons.length > 0) {
            dispatch(
              setCustomerCouponsCount(
                couponPointsDataFromLocalStorage.length + changedCoupons.length,
              ),
            );
            setCustomerCouponsCountinLS(
              couponPointsDataFromLocalStorage.length + changedCoupons.length,
            );
            // setCouponPointsDetails([
            //   ...couponPointsDataFromLocalStorage,
            //   ...couponPointsDataFromAPI.customerCoupons,
            // ]);
            setWithExpiry('coupon_point_details', [
              ...couponPointsDataFromLocalStorage,
              ...couponPointsDataFromAPI.customerCoupons,
            ]);
          }
        } else {
          dispatch(
            setCustomerCouponsCount(
              couponPointsDataFromAPI.customerCoupons.length,
            ),
          );
          setCustomerCouponsCountinLS(
            couponPointsDataFromAPI.customerCoupons.length,
          );
          //setCouponPointsDetails(couponPointsDataFromAPI.customerCoupons);
          setWithExpiry(
            'coupon_point_details',
            couponPointsDataFromAPI.customerCoupons,
          );
        }
      }
    }
    setShowUnlockedModel(false);
    setTimeout(() => {
      setCanScan(true);
    }, 2000);

    dispatch(resetCouponAPIResponse());
  }
  const {width} = useWindowDimensions();

  const cameraViewHeight = width - 32 * 2;
  const cameraViewEdgeBoxHeight = cameraViewHeight - (2 * cameraViewHeight) / 3;
  const boxStyles: CSSProperties = {
    height: `${cameraViewEdgeBoxHeight}px`,
    width: `${cameraViewEdgeBoxHeight}px`,
    borderColor: '#d83f38',
  };

  function getValue() {
    if (couponPointsDataFromLocalStorage === null) {
      return couponPointsDataFromAPI;
    } else {
      return couponPointsDataFromLocalStorage;
    }
  }

  return (
    <div className="text-center bg-blue_three child-container relative p-4">
      <div className="absolute barcode-overlay-content bottom-0 flex-col left-0 right-0 top-0 z-10">
        <div className="bg-black_two ">
          <StoreCodeMessage
            title1={'Scan More QR Code To'}
            title2={'Unlock more offers'}
          />
        </div>
        <OfferModal
          open={showUnlockedModel}
          offer={offer}
          onClose={() => {
            handleModalClose('offerModal');
          }}
        />

        <div className="scanner-container">
          <div className="corners">
            {openofferGif ? (
              <div className="absolute z-20 top-1 bottom-1 right-1 left-1  bg-opacity-0">
                <Lottie
                  options={offerscannerGif}
                  style={{borderRadius: '10px'}}
                />
              </div>
            ) : null}

            <div className="tops lefts">&nbsp;</div>
            <div className="tops rights">&nbsp;</div>
            <div className="bottoms rights">&nbsp;</div>
            <div className="bottoms lefts">&nbsp;</div>
            <QrCode onScan={handleScan} canScan={canScan} />
          </div>
        </div>
        <ScannerView
          onButtonClick={handleButtonClick}
          lsCouponPoints={getValue()}
        />
      </div>
    </div>
  );
};

export default Offers;
